import { Component, OnInit, AfterContentInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { UserService } from '../../services/user.service';
import { MatSnackBar } from '@angular/material';
import { AuthService, GoogleLoginProvider } from 'angular-6-social-login';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterContentInit {
  isSubmit: boolean = false;
  loginform: FormGroup;
  errorMessage: string;
  allSub: Subscription[] = [];

  constructor(private router: Router,
    private userService: UserService,
    private fb: FormBuilder,
    public snackBar: MatSnackBar,
    private socialAuthService: AuthService) { }

  ngOnInit() {
    this.loginform = this.fb.group({
      username: [{ value: '', disabled: false }, [Validators.required]],
      password: [{ value: '', disabled: false }, [Validators.required]]
    });
  }

  ngAfterContentInit() {
    if (sessionStorage.getItem("token") !== null) {
      this.router.navigate(['home']);
    }
  }

  onSubmit() {
    let socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;

    this.socialAuthService.signIn(socialPlatformProvider).then(
      (userData) => {
        console.log("google sign in data : ", userData);
        
        this.userService.logIn

        let sub = this.userService.GoogleLogin(userData.idToken)
            .subscribe(
              (data) => {
                if (data.ReturnURL === 'login') {
                  this.errorMessage = data.Message;
                  this.isSubmit = false;

                  this.openSnackBar(data.Message, '');
                } else if (data.ReturnURL === 'home') {
                  this.openSnackBar(data.Message, '');

                  sessionStorage.setItem("token", data.Token);
                  this.router.navigate([data.ReturnURL]);
                } else {
                  this.errorMessage = data.Message;
                  this.isSubmit = false;

                  this.openSnackBar(data.Message, '');
                }
              },
              error => {
                this.errorMessage = <any>error
                this.isSubmit = false;
                this.openSnackBar('Login failed. Please try again.', '');
              });

          // Adds into array for each subscribe
          this.allSub.push(sub);
;      }
    );
  }






  // onSubmit(form: FormGroup) {
  //   this.isSubmit = true;

  //   let sub = this.userService.logIn(
  //     form.get('username').value,
  //     form.get('password').value)
  //     .subscribe(
  //       (data) => {
  //         if (data.ReturnURL === 'login') {
  //           this.errorMessage = data.Message;
  //           this.isSubmit = false;

  //           this.openSnackBar(data.Message, '');
  //         } else if (data.ReturnURL === 'home') {
  //           this.openSnackBar(data.Message, '');

  //           sessionStorage.setItem("token", data.Token);
  //           this.router.navigate([data.ReturnURL]);
  //         } else {
  //           this.errorMessage = data.Message;
  //           this.isSubmit = false;

  //           this.openSnackBar(data.Message, '');
  //         }
  //       },
  //       error => {
  //         this.errorMessage = <any>error
  //         this.isSubmit = false;
  //         this.openSnackBar('Login failed. Please try again.', '');
  //       });

  //   // Adds into array for each subscribe
  //   this.allSub.push(sub);
  // }

  // Unsubscribe service on screen change
  ngOnDestroy() {
    for (let sub of this.allSub) {
      sub.unsubscribe();
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
}
